import React from 'react';

import logo from './assets/images/logo.png';

import NavItem from './components/NavItem'
import packageJson from '../package.json';
import PdfCreator from './utils/PdfCreator';
import {withRouter} from 'react-router-dom'
import Utils from './utils/Utils'
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer
class Header extends React.Component {

  componentDidMount() {
    PdfCreator.fetchData();
  }


  _print(){
      //this.props.history.push(`/${Utils.serverpath}/entry`);
      setTimeout(()=>{PdfCreator.createDoc();},600)

  }
  _pdf(){
     // this.props.history.push(`/${Utils.serverpath}/entry`);
      //setTimeout(()=>{PdfCreator.createDoc(false);},600)
  }
    _save(){

    }

  render() {
    var VERSION = packageJson.version;
    return (
      <header className="layout-header">
        <nav className="navbar navbar-default navbar-fixed-top">
          <div className="container">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-ex-collapse">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"/>
                <span className="icon-bar"/>
                <span className="icon-bar"/>
              </button>
              <a className="navbar-brand" href="https://www.dw-systembau.de">
                <img className="logotop" src={logo} alt="DW Logo"/>
              </a>
            </div>
            <div className="collapse navbar-collapse" id="navbar-ex-collapse">
              <p className="navbar-text"><strong>Kostenvergleich</strong></p>
              <p className="navbar-text"><small>{`Version: ${VERSION}`}</small></p>
              <ul className="nav navbar-nav navbar-right">
                {/*<NavItem exact={true} to={`/${Utils.serverpath}`}>Start</NavItem>*/}
                <NavItem exact={true} to={`/${Utils.serverpath}`} >Basisdaten</NavItem>
                <NavItem exact={true} to={`/${Utils.serverpath}/brespa`} disabled={!this.props.baseDataStore.isPossible.possible}>Kosten und Ergebnisse</NavItem>
                <li onClick={()=>this._print()} className={this.props.baseDataStore.isPossible.possible ? null : 'disabled'}><a style={{userSelect:"none"}} >Drucken</a></li>
                {/*<li onClick={()=>this._pdf()} className={this.props.baseDataStore.isPossible.possible ? null : 'disabled'}><a>PDF</a></li>
                <li onClick={()=>this._save()}><a>Speichern/Laden</a></li>*/}
                <li><a href="hilfe/hilfe.pdf" target="_blank">Hilfe</a></li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}
Header.propTypes = {
    baseDataStore: PropTypes.object.isRequired
}

export default withRouter(Header);




// WEBPACK FOOTER //
// ./src/Header.js